export default "__VITE_ASSET__DCLi6DeS__"